import concatIf from './concat-if.js';

export default (params) => {
  const queryString = Object
    .entries(params)
    .filter((param) => param[1])
    .map((param) => `${ param[0] }=${ param[1] }`)
    .join('&');

  return concatIf('?', queryString);
}
